import { ccwpApi } from "@/services";
import { BULK__IMPORT__DOCUMENT } from "../constant/apiPath";
// Define a service using a base URL and expected endpoints
export const BulkImportApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    bulkImportDocument: builder.mutation({
      query: (formData) => {
        if (formData?.get("file")?.name?.endsWith(".msg")) {
          const correctedFile = new Blob([formData.get("file")], {
            type: "application/vnd.ms-outlook",
          });
          formData.set("file", correctedFile, formData.get("file").name);
        }
        return {
          url: BULK__IMPORT__DOCUMENT,
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useBulkImportDocumentMutation } = BulkImportApi;
